import React from 'react';
import { Location, useLocation } from 'react-router';
import { Breadcrumb } from '@progress/kendo-react-layout';
import styles from './styles.module.scss';
import { PageToolbar } from '@components-clean/core/page-toolbar/page-toolbar';
import { ILocalState } from '@contexts/local-state-context';
import { useLocalState, useTranslation } from '@hooks/index';

const PageBreadcrumbs = ({
    breadcrumbs,
}: {
    breadcrumbs: (string | ((state: ILocalState, location: Location) => string))[];
}) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { state } = useLocalState();

    const convertedBreadcrumbs = breadcrumbs?.map((item) => {
        if (typeof item === 'string') {
            return { id: item, text: t(item) };
        }
        if (state != null) {
            const val = item(state, location);
            return { id: val.replace(' ', ''), text: val };
        }

        throw new Error('broken!');
    });

    return (
        <div className={styles.pageBreadcrumbs}>
            <Breadcrumb data={convertedBreadcrumbs} className={styles.breadcrumb} />
            <PageToolbar />
        </div>
    );
};

export default PageBreadcrumbs;
